module.exports = __webpack_public_path__ + "img/语音.0c8ee710.png";